/* Componente per selezionare il layer per eseguire la query*/
import React from 'react';
import {useEffect} from 'react'
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  selectEmpty: {
    marginTop: theme.spacing(0),
  },
}));

function SelectLayer(props) {

  const dataLayers = []
  
    
  props.data.children.map(x=>{
    
    x.children.map(y=>{
      
      dataLayers.push({name: y.name, serviceUrl: y.serviceUrl, infoField:y.infoField})
      return null
    })
    return null
  })

  const classes = useStyles();
  const [status, setStatus] = React.useState('');
  // const [_, setLayerValue] = React.useState('')

  useEffect(()=>{
    setStatus('')
    // setLayerValue('')
  },[props.start])

useEffect(()=>{
  if (props.openQuery.state === true){
    // setStatus(props.openQuery.name.name);
    dataLayers.map((x,index)=>{
      if (x.name ===props.openQuery.name){
        props.callback(dataLayers[index])
        setStatus(index);
      }
      return null
    })
  }
},[props.openQuery])

  const handleChange = (event) => {
    props.callback(dataLayers[event.target.value])
  setStatus(event.target.value);
  // setLayerValue(dataLayers[event.target.value])
  };
  const select =(dati,index)=>{
      return (
        <MenuItem key={index} value={index} >
        {dati.name}
      </MenuItem>)
  }

  return (
    
        <FormControl className={"formControl"} >
        <Select
        
          value={status}
          onChange={handleChange}
          displayEmpty
          className={classes.selectEmpty}
          inputProps={{ 'aria-label': 'Without label' }}
          
        >
          {dataLayers.map((item, index) => (
              select(item,index)
          ))}
            
           
        </Select>
      </FormControl>
   )}

   const mapStateToProps = state => {
    return {
        openQuery:state.openQuery.openQuery
    }
  }
  export default connect(mapStateToProps) (SelectLayer)